import { useTableActionContext } from '@aibees/elephant/context';
import { AddExportSearchRequestBody } from '@aibees/elephant/hooks';
import { useMemo } from 'react';
import { useIntegrationContext } from '../context/integration-context';

export function usePrepareDataForIntegrationSetting() {
  const { integrationExportSetting, selectedCampaign, selectedIntegration } =
    useIntegrationContext();
  const { integrationConfig } = useTableActionContext();

  return useMemo(() => {
    if (!integrationConfig?.type) return undefined;

    return {
      [integrationConfig?.type]: {
        id: selectedIntegration?.id,
        setting: {
          campaignId: selectedCampaign?.id,
          settings: integrationExportSetting,
        },
      },
    } as AddExportSearchRequestBody['integrations'];
  }, [
    integrationExportSetting,
    integrationConfig?.type,
    selectedCampaign?.id,
    selectedIntegration?.id,
  ]);
}
